import styled from 'styled-components'
import rightIcon from '../../asset/direction-right.svg'
import upIcon from '../../asset/direction-up.svg'
import downIcon from '../../asset/direction-down.svg'
import crossIcon from '../../asset/cross.svg'
import theme from '../../styles/theme'
const LinkBtn = styled.button`
  padding: 0px;
  font-size: 1rem;
  line-height: 1.5;
  display: flex;
  color: ${theme.color.btnText};
  appearance: none;
  background: transparent;
  cursor: pointer;
  border: none;
  text-decoration-skip-ink: auto;
  text-decoration: underline;
  align-items: center;
  margin: ${({ isDepenednt }) => (isDepenednt ? '24px 0px' : '0px')};
`

export const Left = styled(LinkBtn)`
  display: inline-block;
  ::before {
    display: inline-block;
    width: auto;
    height: auto;
    margin: 0 0.25rem;
    content: '←';
  }
`
export const Right = styled(LinkBtn)`
  ::after {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin: 0 0.25rem;
    content: '';
    background-image: url(${rightIcon});
  }
`
export const Up = styled(LinkBtn)`
  ::after {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin: 0 0.25rem;
    content: '';
    background-image: url(${upIcon});
  }
`
export const Down = styled(LinkBtn)`
  ::after {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin: 0 0.25rem;
    content: '';
    background-image: url(${downIcon});
  }
`
export const Close = styled(LinkBtn)`
  display: inline-block;
  ::before {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 0 0.25rem;
    content: '';
    background-image: url(${crossIcon});
  }
`
